// extracted by mini-css-extract-plugin
module.exports = {"info":"InviteRouter_info__2_X5-"};